import { BASE_URL_API } from '../../References/URLs'

// Shared POST helper for every sm_* endpoint — same auth/session
// handling as the rest of the app (token + tokenExpired → logout),
// but with the store key the Special Moments backend actually expects.
export const smPost = async (authCtx, activeStore, resource, payload = {}) => {
    try {
        const res = await fetch(BASE_URL_API + resource, {
            method: 'POST',
            body: JSON.stringify({
                token: authCtx?.token,
                store_identifier: activeStore?.storeIdentifier,
                ...payload,
            }),
        })
        if (!res.ok) return null
        const data = await res.json()
        if (data?.message === 'tokenExpired') {
            authCtx.logout()
            return null
        }
        return data
    } catch {
        return null
    }
}

export const getTodayIso = () => {
    const date = new Date()
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 10)
}

const isSameLocalDay = (a, b) =>
    a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()

// "Today, 9:12 AM" / "Yesterday, 6:40 PM" / "20 Jul, 6:40 PM"
export const formatActivityTimestamp = (isoString) => {
    if (!isoString) return ''
    const date = new Date(isoString)
    const time = date.toLocaleTimeString('en-IN', { hour: 'numeric', minute: '2-digit', hour12: true })
    const today = new Date()
    const yesterday = new Date()
    yesterday.setDate(today.getDate() - 1)

    if (isSameLocalDay(date, today)) return `Today, ${time}`
    if (isSameLocalDay(date, yesterday)) return `Yesterday, ${time}`
    return `${date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' })}, ${time}`
}

// occasion_date on read endpoints (sm_get_customer_profile) comes back
// as "MM-DD" with no year — format it without assuming a year exists.
export const formatOccasionMonthDay = (mmdd) => {
    const [month, day] = (mmdd || '').split('-').map(Number)
    if (!month || !day) return ''
    return new Date(2000, month - 1, day).toLocaleDateString('en-IN', { day: 'numeric', month: 'long' })
}
